import api from "../api/userApi";
import * as url from "../api/userURL";

export const GetAllLeaderBoardList = ({
  username,
  cryptoId,
  activeStep,
  pageLimit,
}) => {
  return new Promise(async (resolve, reject) => {
    return api
      .get(
        url.LEADER_BOARD +
          "?" +
          (username ? `referral_code=${username}` : "") +
          (cryptoId ? `&crypto=${cryptoId}` : "") +
          (activeStep ? `&timestamp=${activeStep}` : "") +
          pageLimit
      )
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
